export class Hebergement {
   
    id_hebergement: number;

    designation: string;
    nom_prenom: string;
    client: string;
    type_chambre: string;
    priseEnCharge: string;
    transport: string;


    date_arrive: Date;
    date_depart: Date; 
d1:string;
d2:string;
    payeeS: string;
    payee: boolean;
    observation: string;
    devise: string;
    tarif: number
    nbr_chambre: number;
    nbr_nuitee: number
 

    pension: boolean;
    demi_pension: boolean;
    chambre_unique: boolean;


    factureClient:string;
    factureHotel:string;


    

}
